import { useState } from "react";
import ChatArrowSVG from "../../../assets/icons/svg/ChatArrowSVG";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { useDispatch } from "react-redux";
import { sendMessage } from "../../../reduxStore/entities/messages";
import { getTargetUserId } from "../../../utils/helpers/getTargetUserId";
import { getUserObject } from "../../../../../utils/getUserObject";

export const SendMessageForm = ({
    partOfferStatus,
    partOfferId,
    conversationUserIds,
    onMessageSent
}) => {

    const dispatch = useDispatch();
    const [messagePayload, setMessagePayload] = useState('');

    const targetUserId = getTargetUserId(conversationUserIds);
    const isDisabled = partOfferStatus !== 1 && getUserObject()?.role === 'seller';



    const getMessagePayload = () => {
        return {
            part_offer_id: partOfferId,
            target_user_id: targetUserId,
            body: messagePayload,
        };
    };

    const handleMessageSend = async () => {
        if (!messagePayload.trim() || isDisabled) return;

        const payload = getMessagePayload();

        try {
            await dispatch(sendMessage(payload));
            setMessagePayload('');
            await onMessageSent();

        } catch (err) {
            console.error('Greška prilikom slanja poruke:', err);
        }
    };




    return (
        <div style={styles.mainContianer}>
            <input
                value={messagePayload}
                onChange={(e) => setMessagePayload(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleMessageSend();
                    }

                }}
                disabled={isDisabled}
                placeholder="Upiši poruku za kupca"
                style={{
                    ...styles.input,
                    backgroundColor: isDisabled ? '#f0f0f0' : 'transparent',
                    cursor: isDisabled ? 'not-allowed' : 'text'
                }}
            />
            <div
                onClick={!isDisabled ? handleMessageSend : undefined}
                style={{
                    ...styles.sendMessageButtonContianer,
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}            >
                <ChatArrowSVG />
            </div>
        </div>

    );
};

export default SendMessageForm;

const styles = {
    mainContianer: {
        display: 'flex',
        alignItems: 'center',
        width: "340px",
        border: "1px solid #0000003b",
        borderRadius: 4,
        padding: "10px"
    },
    input: {
        flex: 1,
        backgroundColor: 'transparent',
        border: "1px solid transparent",
        borderRadius: 6,
        paddingInline: 8,
        fontFamily: FontEnum.TITILIUM_WEB,
    },
    sendMessageButtonContianer: {
        display: 'flex',
        height: "40px",
        width: "40px",
        borderRadius: 8,
        backgroundColor: "#7C3AED",
        alignItems: 'center',
        justifyContent: 'center'
    }
}
